import { EmailDataInterface } from "../email-interfaces";
import  getBrandDetails  from "../brand-data";    

const em7 = ({
monthly_amount,
customername, 
    default_date,
    vehicle_reg,
    default_fee,
    total_due,
    cancellation_date,
button1_link,
button2_link,
button2_num,


 brandCode,

}: EmailDataInterface) => {  
    const brandDetails = getBrandDetails(`${brandCode}`);
    const logo = brandDetails?.logo;
    const bgImgLink = brandDetails?.brandStyling?.bgImgLink;
       const buttonColor = brandDetails?.brandStyling?.buttonColor;
    const headerBg = brandDetails?.brandStyling?.headerBg;
    return `<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN" "http://www.w3.org/TR/html4/loose.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml"
    xmlns:o="urn:schemas-microsoft-com:office:office">

<head>

    <title>PAYMENT STILL OUTSTANDING</title>

    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
    <meta name="x-apple-disable-message-reformatting">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <style type="text/css">
        a {
            text-decoration: none;
            outline: none;
        }

        @media only screen and (min-width: 450px) {
            #mobile {
                display: none;
            }

        }

        @media screen {
            @font-face {
                font-family: 'Roboto';
                font-style: normal;
                font-weight: 400;
                src: local("Roboto"), local("Roboto-Regular"), url(https://fonts.gstatic.com/s/roboto/v18/KFOmCnqEu92Fr1Mu7GxKOzY.woff2) format("woff2");
                unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
            }

            @font-face {
                font-family: 'Roboto';
                font-style: normal;
                font-weight: 400;
                src: local("Roboto"), local("Roboto-Regular"), url(https://fonts.gstatic.com/s/roboto/v18/KFOmCnqEu92Fr1Mu4mxK.woff2) format("woff2");
                unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
            }

            @font-face {
                font-family: 'Roboto';
                font-style: normal;
                font-weight: 700;
                src: local("Roboto Bold"), local("Roboto-Bold"), url(https://fonts.gstatic.com/s/roboto/v18/KFOlCnqEu92Fr1MmWUlfChc4EsA.woff2) format("woff2");
                unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
            }

            @font-face {
                font-family: 'Roboto';
                font-style: normal;
                font-weight: 700;
                src: local("Roboto Bold"), local("Roboto-Bold"), url(https://fonts.gstatic.com/s/roboto/v18/KFOlCnqEu92Fr1MmWUlfBBc4.woff2) format("woff2");
                unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
            }

            .o_sans,
            .o_heading {
                font-family: "Roboto", sans-serif !important;
            }

            .o_heading,
            strong,
            b {
                font-weight: 700 !important;
            }

            a[x-apple-data-detectors] {
                color: inherit !important;
                text-decoration: none !important;
            }
        }

        #canvas .o_hide,
        #canvas .o_hide-lg {
            font-size: inherit !important;
            max-height: none !important;
            width: auto !important;
            line-height: inherit !important;
            visibility: visible !important;
        }

        #canvas td.o_hide,
        #canvas td.o_hide div {
            display: block !important;
            font-family: "Roboto", sans-serif;
            font-size: 16px !important;
            color: #000;
        }

        #canvas span.o_hide-lg {
            display: inline-block !important;
            vertical-align: top;
        }

        .CodeMirror {
            line-height: 1.4;
            font-size: 12px;
            font-family: sans-serif;
        }

        @media (max-width: 640px) {
            .headerLogo {
                padding-left: 15px !important;
                padding-right: 15px;
            }

            .headerbutton {
                padding-left: 15px;
                padding-right: 15px !important;
            }
        }

        @media only screen and (max-width:480px) {
            .width-mobile {
                width: 100% !important;
            }
        }

        @media only screen and (max-width:600px) {
            .main-wrapper {
                min-width: 100% !important;
            }

            .email-nav {
                margin-bottom: 0 !important;
                min-width: 100% !important;
                box-shadow: 0px 2px 12px rgba(10, 25, 43, 0.108665) !important;
                position: relative !important;
                border-bottom: 1px solid #e4e4e4;
            }

            .email-body {
                box-shadow: none !important;
                border-radius: 0 !important;
                min-width: 100% !important;
                width: 100% !important;
                margin-top: 0 !important;
                padding-left: 0 !important;
                padding-right: 0 !important;
                padding-top: 0 !important;margin-bottom: 0 !important;
            }

            .spacer {
                display: none !important;
            }

            .featuresWrapper {
                display: block !important;

            }

            .featuresWrapperCol {
                min-width: 100% !important;
                max-width: 100% !important;
                display: block;
            }

            .featuresWrapperColImg {
                min-width: 100% !important;
                max-width: 100% !important;
                text-align: center !important;
                padding-top: 20px;
                padding-bottom: 20px;
                display: block !important;
            }

            .emailFooter {
                display: block;
            }

            .emailFooterCol {
                width: 100% !important;
                text-align: center !important;
                display: block !important;
            }

            .footerButtons {
                display: block !important;
            }

            .footerButtonsCol {
                display: block !important;
                width: 100% !important;
                text-align: center !important;
                padding-left: 0 !important;
                padding-right: 0 !important;
                margin-top: 10px;
            }

            .mainTitle {
                font-size: 24px !important;
                line-height: 31px !important;
                padding-bottom: 6px !important;
            }

            .hiddenMob {
                display: none !important;
            }

            .mobileSpacer {
                height: 20px !important;
            }

            .headerbuttonMedia {
                width: 120px !important;
            }

            .bannerTop {
                padding-left: 10px !important;
                padding-right: 10px !important;

            }

            .bannerTop__title {
                font-size: 12px !important;
                margin-bottom: 0px !important;
            }

            .bannerTop__text {
                font-size: 15px !important;
            }

            .contnetPadding {
                padding-left: 20px !important;
                padding-right: 20px !important;
            }

            .downloadAppContnet__title {
                font-size: 16px !important;
            }

            .videoWrapper {
                height: auto !important;
                min-height: 161px !important;
            }

            .PaddingNone {
                padding-left: 0 !important;
                padding-right: 0 !important;
            }
        }

        body,
        * {
            font-family: "Mulish", sans-serif;
        }
    </style>



</head>

<body marginwidth="0" marginheight="0"
    style="margin-top: 0; margin-bottom: 0; padding: 0; padding-top: 0; padding-bottom: 0; width: 100%; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; background: #ece9fa;"
    offset="0" topmargin="0" leftmargin="0">
    <table class="main-wrapper" width="100%" border="0" cellspacing="0" cellpadding="0"
        style="width:100%; min-width: 600px;  margin-left: 0; margin-right: 0;background-image: url(${bgImgLink});  background-size: cover; ">
        <tbody>
            <tr>
                <td>
                    <table class="email-nav" width="100%" border="0" cellspacing="0" cellpadding="0" bgcolor="#fff"
                        style="width:100%; min-width: 600px; background: #fff; box-shadow: 0px 2px 12px #BED0E5; margin-bottom: 20px;">
                        <tbody>
                            <tr>
                                <td class="mobileSpacer" height="30" style="height: 30px;">

                                </td>
                                <td class="mobileSpacer" height="30" style="height: 30px;">

                                </td>
                            </tr>
                            <tr>
                                <td class="headerLogo" align="center" width="100%"
                                    style="text-align: center; width: 100%; ">
                                    <img width="229" height="39"
                                        style="width: 229px; height: 39px; max-width: 100%; height: auto;"
                                        src=${logo}
                                        alt="Debt Sure Logo">
                                </td>



                            </tr>
                            <tr>
                                <td class="mobileSpacer" height="30" style="height: 30px;">

                                </td>
                                <td class="mobileSpacer" height="30" style="height: 30px;">

                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="spacer">
                        <tbody>
                            <tr>
                                <td style="height: 30px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <table class="email-body" width="600" border="0" align="center" class="width-mobile" cellspacing="0"
                        cellpadding="0" style="width:600px; border-radius: 0px; box-shadow: 0px 5px 25px rgba(56, 120, 197, 0.198235); max-width:600px;background: #fff;padding-left:30px; padding-right: 30px; padding-top: 30px;
                              margin-top: 20px; margin-bottom: 60px; ">
                        <tbody>
                            
                            <tr style="background: #fff;">
                                <td>
                                    <table data-module="invoice-details-primary"
                                        data-thumb="http://www.stampready.net/dashboard/editor/user_uploads/zip_uploads/2020/03/09/ekDrl0bgnsdjYK6aR3IGpNih/account_deleted/thumbnails/invoice-details-primary.png"
                                        width="100%" cellspacing="0" cellpadding="0" border="0" role="presentation"
                                        style="opacity: 1;">

                                        <tr>
                                            <td class="o_bg-light o_px-xs" align="center">

                                                <table class="o_block-xs" width="100%" cellspacing="0" cellpadding="0"
                                                    border="0" role="presentation"
                                                    style="max-width: 600px; margin: 0px auto; height: 86px;">

                                                    <tr>
                                                        <td class="bannerTop o_re o_bg-primary o_px o_pb-md"
                                                            align="center" data-bgcolor="Bg Primary"
                                                            style="font-size: 15px; vertical-align: middle; background-color: ${headerBg}; padding-top: 15px;
    padding-bottom: 15px; ">
                                                            <table style="width: 100%; text-align: center;"
                                                                align="center">
                                                                <tr>
                                                                    <td> <img width="36" height="36"
                                                                            style="width: 36px; height: 36px; max-width: 100%; height: auto;"
                                                                            src="https://designway.github.io/images/img/debt-sure/failed.png"
                                                                            alt="success"></td>
                                                                </tr>
                                                                <tr>
                                                                    <td><span style="color: #fff; line-height: 24px;
    letter-spacing: 1px; text-transform:uppercase" for="">PAYMENT STILL OUTSTANDING</span></td>
                                                                  
                                                                </tr>
                                                               <tr>
                                                                    <td><span style="color: #fff; line-height: 27px;
    letter-spacing: 0px; font-size:24px" >Your Insurance Cover Is at Risk</span></td>
                                                                  
                                                                </tr>
                                                            </table>



                                                        </td>

                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>

                                    </table>
                                    <table data-module="hero-icon-outline"
                                        data-thumb="http://www.stampready.net/dashboard/editor/user_uploads/zip_uploads/2020/03/09/ekDrl0bgnsdjYK6aR3IGpNih/account_deleted/thumbnails/hero-icon-outline.png"
                                        width="100%" cellspacing="0" cellpadding="0" border="0" role="presentation">

                                        <tr>
                                            <td class="o_bg-light o_px-xs" align="center">

                                                <table class="o_block-xs" width="100%" cellspacing="0" cellpadding="0"
                                                    border="0" role="presentation"
                                                    style="max-width: 600px; margin: 0px auto; height: 160px;">

                                                    <tr>
                                                        <td class="contnetPadding o_bg-ultra_light o_px-md o_py-xl o_xs-py-md o_sans o_text-md o_text-light"
                                                            align="center" data-bgcolor="Bg Ultra Light"
                                                            data-color="Light" data-size="Text MD" data-min="15"
                                                            data-max="23"
                                                            style="font-family: Helvetica, Arial, sans-serif; margin-top: 0px; margin-bottom: 0px; font-size: 18px; line-height: 25.2px; color: rgb(130, 137, 154); padding: 33px 20px 0px;">
                                                            <table cellspacing="0" cellpadding="0" border="0"
                                                                role="presentation" style="width :100%;">

                                                                <tr>
                                                                    <td style="text-align: center;">
                                                                        <img width="35" height="35"
                                                                            style="width:35px; height: 35px;"
                                                                            src="https://designway.github.io/images/img/email_temp/docusure/hand.png"
                                                                            alt="">
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td class="o_sans o_text o_text-secondary o_b-primary o_px o_py o_br-max"
                                                                        align="center" data-color="Secondary"
                                                                        data-size="Text Default" data-min="12"
                                                                        data-max="20"
                                                                        data-border-top-color="Border Primary"
                                                                        data-border-bottom-color="Border Primary"
                                                                        data-border-left-color="Border Primary"
                                                                        data-border-right-color="Border Primary"
                                                                        style="font-family: Helvetica, Arial, sans-serif; margin-top: 0px; margin-bottom: 0px; font-size: 17px; line-height: 23.799999999999997px; color: rgb(66, 70, 81);  border-top-left-radius: 96px; border-top-right-radius: 96px; border-bottom-right-radius: 96px; border-bottom-left-radius: 96px; ">
                                                                        <h2 class="mainTitle o_heading o_text-dark o_mb-xxs"
                                                                            data-color="Dark" data-size="Heading 2"
                                                                            data-min="20" data-max="40"
                                                                            style="font-family: Helvetica, Arial, sans-serif; font-weight: bold; margin-top: 0px; margin-bottom: 0px; color: #233F6F; font-size: 28px; line-height: 39.199999999999996px; letter-spacing: 0px;">
                                                                            Dear ${customername},</h2>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td
                                                                        style="font-size: 24px; line-height: 5px; height: 10px;">
                                                                        &nbsp;
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td style="
                                                                    
                                                                    flex-shrink: 0;background: #E6E9F6;
                                                                    color: #26385D;
                                                                    text-align: center;
                                                                    font-size: 17px;
                                                                    font-style: normal;
                                                                    font-weight: 500;
                                                                    line-height: 24px;
                                                                    padding:10px;
                                        
                                                                   letter-spacing: 0px;">
                                                                      <b>${vehicle_reg} – Immediate Payment Required to Avoid Cancellation</b>
                                                                    </td>
                                                                </tr>
                                                              
         <tr>
                                                                    <td style="color: #26385D;
                                                                    text-align: center;
                                                                    font-size: 15px;
                                                                    font-style: normal;
                                                                    font-weight: 400;
                                                                    letter-spacing: 0px;line-height: 24px; padding: 8px 12px 22px;
                                                                    padding-bottom: 0px;">

                                                       Your balance of <b>£${total_due}</b> for your insurance policy covering vehicle registration <b>${vehicle_reg}</b> remains unpaid.
                                                                      
                                                                    </td>
                                                                </tr>

                                                                  <tr>
                                                                    <td style="color: #26385D;
                                                                    text-align: center;
                                                                    font-size: 15px;
                                                                    font-style: normal;
                                                                    font-weight: 400;
                                                                    letter-spacing: 0px;line-height: 24px; padding: 8px 12px 22px; padding-bottom: 0px;
                                                                    ">
                                                     <b> Please make payment today to stop your insurance being cancelled on ${cancellation_date}.</b>
                                                                      
                                                                      
                                                                    </td>
                                                                </tr>

                                                                  <tr>
                                                                    <td style="color: #26385D;
                                                                    text-align: center;
                                                                    font-size: 15px;
                                                                    font-style: normal;
                                                                    font-weight: 400;
                                                                    letter-spacing: 0px;line-height: 24px; padding: 8px 12px 22px;
                                                                   ">

                                                                     
Failure to pay will not only lead to the cancellation of your insurance cover but may also affect your credit record and result in additional recovery fees.
                                                                      
                                                                    </td>
                                                                </tr>

                                        
                                                                 <tr>
                                                                    <td
                                                                        style="text-align: center; background: #F0F4FA;padding-bottom: 20px; padding-top: 10px">
                                                                        <table style="width: 100%;">
                                                                            <tr>
                                                                                <td style="color: #233F6F;
                                                                                text-align: center;
                                                                                font-size: 15px;
                                                                                font-style: normal;
                                                                                font-weight: 500;
                                                                                line-height: 24px; padding: 10px 18px; letter-spacing: 0.7px;">
                                                                                  
<span style="  color: #233F6F;
                                                                    text-align: center;
                                                                    font-size: 15px;
                                                                    font-style: normal;
                                                                    font-weight: 500;

                                                                    line-height: 30px; letter-spacing: 0px; text-transform:uppercase">  <b>Immediate Action Required:</b>         </span> <br>                                                                                                                                             
                                                                             Please make payment today using one of the secure methods below:
                                                                                </td>
                                                                            </tr>

                                                                          
                                                                            <tr>
                                                      <td style="padding-bottom: 5px;text-align: center;">
                                                                            <a style="background-color: ${buttonColor};display: block; width:200px;color:#fff;padding: 14px 0; border-radius: 2px;margin: auto;color:#fff;text-align: center;font-size: 12px;font-style: normal;font-weight: 500;line-height: 1;" href="${button1_link}" target="_blank"> 
                                                                                  <img 
                                        style="width: 22px; height: 22px; vertical-align:middle; padding-right: 5px" width="20" height="22"
                                        src="https://designway.github.io/images/img/debt-sure/laptop-icon.png"
                                        alt="laptop-icon">   
                                                                            
                                                                  Pay Online
                                                                                </a>
                                                                                  
                                                                                  
                                                                            </td>
                                                                            </tr>

                                                                             <tr>
                                                                                <td align="center" style="padding: 10px 0;">
  <table role="presentation" cellpadding="0" cellspacing="0" border="0" 
         style="background:${buttonColor}; border-radius:2px; width:200px;">
    <tr>
      <td align="center" 
          style="padding:8px 12px;">

        <a href="tel:${button2_num}"
           style="display:block; text-decoration:none; color:#ffffff;">

          <table role="presentation" cellpadding="0" cellspacing="0" border="0">
            <tr>
              <!-- ICON -->
              <td style="padding-right:4px;">
                <img src="https://designway.github.io/images/img/debt-sure/phone-icon.png" 
                     width="28" height="28" 
                     style="display:block; border:0;">
              </td>

              <!-- TEXT -->
              <td style="text-align:left; color:#ffffff;">
                <div style="font-size:12px; font-weight:500; line-height:14px;">
                  Pay by Phone
                </div>
                <div style="font-size:15px; margin-top:2px; font-weight:700; line-height:18px;">
                  ${button2_num}
                </div>
              </td>
            </tr>
          </table>

        </a>

      </td>
    </tr>
  </table>
</td>
                                                                            </tr>
                                                                                    </table>
                                                                    </td>
                                                                </tr>
                                                            

                                                        </td>
                                                    </tr>

                                                </table>

                                            </td>
                                        </tr>
                                    </table>
                                    <table data-module="content-lg"
                                        data-thumb="http://www.stampready.net/dashboard/editor/user_uploads/zip_uploads/2020/03/09/ekDrl0bgnsdjYK6aR3IGpNih/account_deleted/thumbnails/content-lg.png"
                                        width="100%" cellspacing="0" cellpadding="0" border="0" role="presentation">

                                        <tr>
                                            <td class="o_bg-light o_px-xs" align="center"
                                                style="padding: 20px 20px 20px;">

                                                <table class="o_block-xs" width="100%" cellspacing="0" cellpadding="0"
                                                    border="0" role="presentation"
                                                    style="max-width: 600px; margin: 0px auto; height: 234px; ">

                                                    <tr>
                                                        <td colspan="3" style="background: #D7E2F2;color: #233F6F;
                                                    text-align: center;
                                                    font-size: 17px;
                                                    font-style: normal;
            
                                                    letters-spacing:1px;
                                                    line-height: 20px;height: 30px;border-bottom: 2px solid #fff;">
                                                            <b>PAYMENT DETAILS</b></td>
                                                    </tr>

                                             

                                                  
                                                    
                                               <tr style="background-color: #F0F4FA;color: #26385D;
                                                        font-size: 16px;
                                                        font-style: normal;
                                                        letter-spacing: 0px;">
        
                                                          
                                                                <td
                                                                    style=" font-weight: 500;  height: 49px; border-bottom: 1px dashed #D4DBE7; padding-left: 20px;" colspan="2" >
                                                                    <b>Day of Default</b>
                                                                </td>
        
                                                                <td
                                                                    style=" height: 49px; border-bottom: 1px dashed #D4DBE7;padding-right: 20px; text-align: right;">
                                                                    ${default_date} </td>
                                                            </tr>
                                                  
                                                                                       <tr style="background-color: #F0F4FA;color: #26385D;
                                                        font-size: 16px;
                                                        font-style: normal;
                                                        letter-spacing: 0px;">
        
                                                          
                                                                <td
                                                                    style=" font-weight: 500;  height: 49px; border-bottom: 1px dashed #D4DBE7; padding-left: 20px;" colspan="2" >
                                                                    <b>Default Amount</b>
                                                                </td>
        
                                                                <td
                                                                    style=" height: 49px; border-bottom: 1px dashed #D4DBE7;padding-right: 20px; text-align: right;">
                                                                     £${monthly_amount} </td>
                                                            </tr>
                                                  
                                                        <tr style="background-color: #F0F4FA;color: #26385D;
                                                        font-size: 16px;
                                                        font-style: normal;
                                                        letter-spacing: 0px;">
        
                                                          
                                                                <td
                                                                    style=" font-weight: 500;  height: 49px; border-bottom: 1px dashed #D4DBE7; padding-left: 20px;" colspan="2" >
                                                                    <b>Default Fee</b>
                                                                </td>
        
                                                                <td
                                                                    style=" height: 49px; border-bottom: 1px dashed #D4DBE7;padding-right: 20px; text-align: right;">
                                                                     £${default_fee} </td>
                                                            </tr>
        
        

                                                    <tr style="background: #E7EFFB;color: #26385D;
                                                font-size: 16px;
                                                font-style: normal;
                                                font-weight: 600;
                                                line-height: 24px; height: 61px;letter-spacing: 0px;">
                                                        <td colspan="2" style="padding-left: 20px; border-bottom: 1px dashed #D4DBE7;"><b>Total Due:</b></td>
                                                        <td style="padding-right: 20px; text-align: right;border-bottom: 1px dashed #D4DBE7">
                                                            <b>£${total_due}</b> </td>
                                                    </tr>

                                                    <tr style="background: #E7EFFB;color: #26385D;
                                                font-size: 16px;
                                                font-style: normal;
                                                font-weight: 600;
                                                line-height: 24px; height: 61px;letter-spacing: 0px;">
                                                        <td colspan="2" style="padding-left: 20px;"><b>Cancellation Date:</b></td>
                                                        <td style="padding-right: 20px; text-align: right;">
                                                            <b>${cancellation_date}</b> </td>
                                                    </tr>

                                                    <tr>
                                                        <td style="height:21px;"> &nbsp;</td>
                                                    </tr>


                                                     <tr>
                                                        <td colspan="3" style="letter-spacing: 0px;    background:#F0F4FA;
                                                 padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 8px;
                                                  " >
                                         <table width="100%" height="100%" style="width: 100%;" cellspacing="0" cellpadding="0" border="0">
  <tr style="color: #233F6F; font-size: 15px; font-style: normal; line-height: 26px; letter-spacing: 0px;">
    <td style="padding-left: 20px; text-transform:uppercase; padding-bottom:8px;" colspan="3">
      <b>Important Notice:</b>
    </td>
  </tr>
  <tr style="color: #233F6F; font-size: 15px; font-style: normal; font-weight: 500; line-height: 25px; letter-spacing: 0px;">
    <td width="14" style="padding-left:20px; width:14px; vertical-align: top;">
      <img src="https://designway.github.io/images/img/debt-sure/arrow-right.png"
           width="4" height="7" alt="arrow-right"
           style="display:block; width:4px; height:7px; margin-top:9px;">
    </td>
    <td style="font-weight:500;">
      Your insurance will be cancelled on ${cancellation_date} if this remains unpaid.
    </td>
  </tr>
  <tr style="color: #233F6F; font-size: 15px; font-style: normal; font-weight: 500; line-height: 25px; letter-spacing: 0px;">
    <td width="14" style="padding-left:20px; width:14px; vertical-align: top;">
      <img src="https://designway.github.io/images/img/debt-sure/arrow-right.png"
           width="4" height="7" alt="arrow-right"
           style="display:block; width:4px; height:7px; margin-top:9px;">
    </td>
    <td style="font-weight:500;">
      Cancellation makes it harder to secure future insurance.
    </td>
  </tr>
  <tr style="color: #233F6F; font-size: 15px; font-style: normal; font-weight: 500; line-height: 25px; letter-spacing: 0px;">
    <td width="14" style="padding-left:20px; width:14px; vertical-align: top;">
      <img src="https://designway.github.io/images/img/debt-sure/arrow-right.png"
           width="4" height="7" alt="arrow-right"
           style="display:block; width:4px; height:7px; margin-top:9px;">
    </td>
    <td style="font-weight:500;">
      Unpaid balances will be referred to a debt collection agency.
    </td>
  </tr>
  <tr style="color: #233F6F; font-size: 15px; font-style: normal; font-weight: 500; line-height: 25px; letter-spacing: 0px;">
    <td width="14" style="padding-left:20px; width:14px; vertical-align: top;">
      <img src="https://designway.github.io/images/img/debt-sure/arrow-right.png"
           width="4" height="7" alt="arrow-right"
           style="display:block; width:4px; height:7px; margin-top:9px;">
    </td>
    <td style="font-weight:500;">
      Extra fees and credit score damage may follow.
    </td>
  </tr>
</table>




                                            </td>
                                        </tr>

                                          


                                    </table>


   
        <tr>
        <td style="padding: 15px 20px 20px; padding-top:0px;">
        <table cellspacing="0" cellpadding="0" border="0" role="presentation" style="width:100%;">
       

                <tr>
                                                        <td colspan="3" style=" letter-spacing: 0px; border-radius: 6px;
                                                    padding-top: 5px;
                                                    padding-bottom: 5px;
                                                  " >
                                                            <table width="100%" height="100%"
                                                                style="width: 100%;" cellspacing="0"
                                                                cellpadding="0" border="0">
                                                              
                                                              
                                    
                                                                   <tr style="color: #233F6F;
                                                font-size: 15px;
                                                font-style: normal;
                                               
                                                line-height: 26px; letter-spacing: 0px;">
                                                        <td  style=" text-align:center">  <img 
                                        style="width: 18px; height: 17px; object-fit:contain" width="18" height="17"
                                        src="https://designway.github.io/images/img/debt-sure/bulb.png"
                                        alt="arrow-right"> <b>PLEASE NOTE</b></td>
                                                   
                                                    </tr>
        <tr>
        <td style="color: #233F6F;
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;padding-top: 10px;padding-left: 10px;
        padding-right: 10px;padding-bottom: 10px;letter-spacing: 0.7px;">We’re contacting you on behalf of your premium finance provider, <b>Premfina Limited</b>. You may also receive reminders directly from them — this is completely normal. Your payment will be made <b>securely via Premfina’s payment portal,</b> as they manage your monthly instalments on our behalf.</td>
        </tr>
        
        </table>
        </td>
        </tr>
                                  
                                  <tr>
                                    
                                    <td>
                                      
                                    <table width="100%" cellspacing="0" cellpadding="0" border="0" style="background-color: rgb(255, 255, 255); ">


                                  
                            

                                        <tr>
                                            <td style="text-align: center;padding-bottom: 10px; padding-top: 10px;">
                                                <img width="540" style="width: 100%; max-width:540px;"
                                                    src="https://designway.github.io/images/img/weemail/dashed-line.png"
                                                    alt="dotted-border">
                                            </td>
                                        </tr>
                                        <!-- ===#ENDDOWNLOAD APP SECTION=== -->
                                        <tr>
                                            <td class="o_bg-light o_px-xs o_pb-lg o_xs-pb-xs" align="center">
                                                <table class="o_block-xs" width="100%" cellspacing="0" cellpadding="0"
                                                    border="0" role="presentation"
                                                    style="max-width: 600px; margin: 0px auto; height: 60px;">
                                                    <tr>
                                                        <td class="o_bg-white o_px-md o_py-lg o_bt-light o_br-b o_sans o_text-xs o_text-light"
                                                            align="center" data-bgcolor="Bg White" data-color="Light"
                                                            data-size="Text XS" data-min="10" data-max="18"
                                                            style="font-family: 'Mulish', sans-serif;; margin-top: 0px; margin-bottom: 0px; font-size: 16px; line-height: 26px; color: #212735; border-top-left-radius: 0px; border-top-right-radius: 0px; border-bottom-right-radius: 4px; border-bottom-left-radius: 4px; padding: 0px 24px 0px; letter-spacing: 0px;">
                                                           Sincerely, &nbsp;<span
                                                                style="font-size: 20px;"><b><br>&nbsp;DebtSure Team&nbsp;<br> </span></b>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>

                                    </table>
                                      
                                    </td>
                                    
                                  </tr>
        </table>
    



  

                                </td>
                            </tr>

                        </tbody>
                    </table>

                      
                   




 
                </td>
            </tr>

        </tbody>
    </table>

    
             
</body>

</html>`
};

export default em7;
